// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../../common/JQueryView';
import { notificationStatus } from '../../../../models/OfficerApprovalStakeholder';
import { VOTE_DELEGATE } from '../../../../models/companies/stockholder_meetings/Vote';

export default class FormView extends JQueryView {
  constructor() {
    super('.simple_form');
    this.render();
  }

  @on({
    event: 'change',
    selector:
      'select[name="officer_approval_stakeholder[notification_status]"]',
  })
  onChangeHolderType() {
    this.render();
  }

  @on({
    event: 'click',
    selector:
      '.officer_approval_stakeholder_votes_result .form-check-input.radio_buttons',
  })
  hideExclusionInput(event: any) {
    const value = $(event.target)
      .parents('.resolution-edit-row')
      .find(
        '.officer_approval_stakeholder_votes_result .form-check-input.radio_buttons:checked',
      )
      .val();
    const $input = $(event.target)
      .parents('.resolution-edit-row')
      .find('.option .form-check-input.boolean.optional');
    const $option = $(event.target)
      .parents('.resolution-edit-row')
      .find('.option');
    if (value == VOTE_DELEGATE) {
      $input.prop('checked', false);
      $option.addClass('d-none');
    } else {
      $option.removeClass('d-none');
    }
  }

  render() {
    const selectStatus = $(
      'select[name="officer_approval_stakeholder[notification_status]"]',
    ).val();
    if (
      selectStatus == notificationStatus.POST ||
      selectStatus == notificationStatus.UNSENT ||
      selectStatus == notificationStatus.SENT
    ) {
      $('#vote_form').hide();
    } else {
      $('#vote_form').show();
    }
    if (
      selectStatus == notificationStatus.UNSENT ||
      selectStatus == notificationStatus.SENT
    ) {
      $('#document_upload_form').hide();
    } else {
      $('#document_upload_form').show();
    }
    if (selectStatus == notificationStatus.ABSENCE) {
      $('#vote_form').hide();
      $('#document_upload_form').hide();
    }
  }
}
